import { schema } from 'normalizr'

// Types
import { QueryResult } from 'types'

export type LabelsState = {
  [queryString: string]: QueryResult
}
export type Label = {
  id: number
  name: string
  parent: Label
  cover: string
  description: string
  slug: string
}

export const labelSchema = new schema.Entity('labels')
export const labelListSchema = [labelSchema]
